<script setup lang="ts">
import {vAutoAnimate} from '@formkit/auto-animate/vue'
import {FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage} from '../index'
import {PhoneNumberInput} from '../../input'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<{
    name: string
    type?: string
    description?: string
    id?: string
    label?: string
    required?: boolean
  }>(),
  {
    type: 'tel',
  },
)
</script>

<template>
  <FormField v-slot="{componentField}" :name="props.name">
    <FormItem :id="props.id || props.name" v-auto-animate>
      <FormLabel>
        <slot />
        <template v-if="!$slots.default">
          {{ props.label }}
          <span
            v-if="props.required"
            class="label--required text-[color:var(--theme-highlight-color)]"
            >*</span
          >
        </template>
      </FormLabel>
      <FormControl>
        <PhoneNumberInput
          :type="props.type"
          @update:model-value="componentField['onUpdate:modelValue']"
          v-bind="{...$attrs}"
        />
      </FormControl>
      <FormDescription v-if="props.description || $slots.description">
        <template v-if="!$slots.description">
          {{ props.description }}
        </template>
        <slot name="description" />
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
